import React, { useState } from 'react'

import { Box, Button, Collapse, Typography } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import { ChevronUp, ChevronDown, Play, FileText } from 'react-feather'
import { isEmpty } from 'lodash'
import clsx from 'clsx'

import helpers from 'helpers'
import { routes } from 'TrainingRoutes'
import useStyles from './styles'

const LessonRow = ({
  lesson,
  modulePosition,
  lessonIndex,
  portalToken,
  courseId,
  history,
  classes,
}) => {
  const isVideoLesson = lesson?.kind === 'lesson'
  const LessonIcon = isVideoLesson ? Play : FileText
  const lessonNumber = `${modulePosition}.${
    lesson?.position ?? lessonIndex + 1
  }`
  const completedAt = lesson?.completedAt
    ? helpers.formatters.date(lesson.completedAt)
    : null

  const handleAccess = () => {
    const url = (isVideoLesson ? routes.lessonContent : routes.exerciseContent)
      .replace(':portalToken', portalToken)
      .replace(':courseId', courseId)
      .replace(':lessonId', lesson?.id)
    history.push(url)
  }

  return (
    <Box className={classes.lessonRow}>
      <Box className={classes.lessonLeft}>
        <CheckCircle
          className={clsx(classes.checkIcon, {
            [classes.checkIconCompleted]: lesson?.completed,
          })}
        />
        <LessonIcon size={15} className={classes.lessonIcon} />
        <Typography className={classes.lessonTitle}>
          {lessonNumber} - {lesson?.title}
        </Typography>
      </Box>
      <Box className={classes.lessonRight}>
        {completedAt && (
          <Typography className={classes.completedAt}>
            Concluída em: {completedAt}
          </Typography>
        )}
        <Button
          variant="outlined"
          size="small"
          className={classes.actionButton}
          onClick={handleAccess}
        >
          Acessar
          <span className={classes.actionButtonSuffix}>
            &nbsp;{isVideoLesson ? 'Aula' : 'Exercício'}
          </span>
        </Button>
      </Box>
    </Box>
  )
}

const ModuleItem = ({
  module,
  moduleIndex,
  portalToken,
  courseId,
  history,
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(true)

  const lessonsCount = module?.lessonsCount ?? module?.lessons?.length ?? 0
  const durationHours = module?.durationHours ?? 0
  const modulePosition = module?.position ?? moduleIndex + 1

  return (
    <Box className={classes.root}>
      <Box
        className={classes.header}
        onClick={() => setOpen((previous) => !previous)}
      >
        <Box className={classes.headerContent}>
          <Typography className={classes.moduleTitle}>
            {module?.title}
          </Typography>
          <Typography className={classes.moduleMeta}>
            {lessonsCount} {lessonsCount === 1 ? 'aula' : 'aulas'} •{' '}
            {durationHours}
          </Typography>
        </Box>
        {open ? (
          <ChevronUp size={20} className={classes.chevron} />
        ) : (
          <ChevronDown size={20} className={classes.chevron} />
        )}
      </Box>

      <Collapse in={open} default>
        {!isEmpty(module?.lessons) && (
          <Box className={classes.lessonsList}>
            {module.lessons.map((lesson, lessonIndex) => (
              <LessonRow
                key={lesson?.id}
                lesson={lesson}
                modulePosition={modulePosition}
                lessonIndex={lessonIndex}
                portalToken={portalToken}
                courseId={courseId}
                history={history}
                classes={classes}
              />
            ))}
          </Box>
        )}
      </Collapse>
    </Box>
  )
}

export default ModuleItem
